import { render, staticRenderFns } from "./DynamicConfigurationManager.vue?vue&type=template&id=4606f916&scoped=true&"
import script from "./DynamicConfigurationManager.vue?vue&type=script&lang=js&"
export * from "./DynamicConfigurationManager.vue?vue&type=script&lang=js&"
import style0 from "./DynamicConfigurationManager.vue?vue&type=style&index=0&id=4606f916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4606f916",
  null
  
)

export default component.exports